import React from 'react';
import c from 'classnames';

import { SearchResults } from '@uncinc/react-searchkit';
import type { Results } from '@uncinc/react-searchkit/types';

import EmptyState from './EmptyState';
import Hit from './Hit';
import type { SearchAllContentHit } from '../types';

import './style.scss';

/**
 * Hit must be wrapped in a function for it to function.
 */
const renderItem = (hit: SearchAllContentHit) => <Hit {...hit} />;

const SearchAllContentResults: React.FC<Omit<Results, 'renderItem' | 'emptyState'>> = ({
  className,
  ...props
}) => (
  <SearchResults
    className={c('SearchAllContent__Results', className)}
    renderItem={renderItem}
    emptyState={<EmptyState />}
    {...props}
  />
);

export default SearchAllContentResults;
